import { useState, useEffect } from 'react'
import { router } from '@inertiajs/react'
import PropTypes from 'prop-types'
import Modal from '../ui/Modal'
import Input from '../ui/Input'
import Button from '../ui/Button'

export default function AddPartnerModal({ isOpen, onClose }) {
  const [search, setSearch] = useState('')
  const [agencies, setAgencies] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedAgency, setSelectedAgency] = useState(null)

  useEffect(() => {
    if (search.length > 2) {
      setLoading(true)
      const timer = setTimeout(() => {
        fetch(`/collaboration/search_agencies?q=${encodeURIComponent(search)}`)
          .then(res => res.json())
          .then(data => {
            setAgencies(data.agencies)
            setLoading(false)
          })
          .catch(() => setLoading(false))
      }, 300) // Debounce

      return () => clearTimeout(timer)
    } else {
      setAgencies([])
    }
  }, [search])

  const handleAdd = () => {
    if (selectedAgency) {
      router.post('/collaboration/partners', {
        partner_id: selectedAgency.id
      }, {
        onSuccess: () => {
          onClose()
          setSearch('')
          setSelectedAgency(null)
        }
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Ajouter un partenaire">
      <div className="space-y-4">
        <Input
          label="Rechercher une agence"
          placeholder="Nom de l'agence..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />

        {loading && <div className="text-center py-4">Recherche...</div>}

        {agencies.length > 0 && (
          <div className="max-h-64 overflow-y-auto space-y-2">
            {agencies.map(agency => (
              <div
                key={agency.id}
                onClick={() => setSelectedAgency(agency)}
                className={`p-3 border rounded-lg cursor-pointer transition-colors ${
                  selectedAgency?.id === agency.id
                    ? 'border-primary-500 bg-primary-50'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-medium">{agency.name}</h4>
                    <p className="text-sm text-gray-600">{agency.city}</p>
                  </div>
                  <div className="text-right">
                    {agency.current_relationship && (
                      <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded">
                        {agency.current_relationship}
                      </span>
                    )}
                    {!agency.collaboration_enabled && (
                      <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded block mt-1">
                        Collaboration désactivée
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button onClick={handleAdd} disabled={!selectedAgency}>
            Ajouter
          </Button>
        </div>
      </div>
    </Modal>
  )
}

AddPartnerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}
